import { apiGet } from "./client";
import type { ShowListItem, ShowIntelligence, UpcomingShow } from "@shared/types/shows";

export async function getShows(includeHidden = false): Promise<ShowListItem[]> {
  const query = includeHidden ? "?include_hidden=true" : "";
  return apiGet<ShowListItem[]>(`/api/shows${query}`);
}

export async function getUpcomingShows(userId?: number): Promise<UpcomingShow[]> {
  const query = userId ? `?user_id=${userId}` : "";
  return apiGet<UpcomingShow[]>(`/api/shows/upcoming${query}`);
}

export async function getIntelligence(showId: number): Promise<ShowIntelligence> {
  return apiGet<ShowIntelligence>(`/api/intelligence?show_id=${showId}`);
}
